// Module
var code = "<div class=\"vui-settings-section-separator\"></div>";
// Exports
module.exports = code;